// FLEX SLIDER
$(window).load(function() {
	var carSlider = $("#carSlider");
	var carThumb  = $("#carThumb");

	var sliderData = {
		animation: "slide",
		controlNav: false,
		animationLoop: false,
		slideshow: false,
		smoothHeight: true,
		sync: "#carThumb"
	};
	var thumbData = {
		animation: "slide",
		controlNav: false,
		animationLoop: false,
		slideshow: false,
		itemWidth: 210,
		itemMargin: 5,
		asNavFor: '#carSlider'
	};

	function notifyGalleryInit() {
		window.dispatchEvent(new Event("listingGalleryFlexsliderInit"));
	}

	if(carSlider[0] !== undefined) {

		// slider init
		carSlider.flexslider(sliderData);
		carThumb.flexslider(thumbData);
		notifyGalleryInit();

		// Slider resize
		window.addEventListener("resize", function() {
			removeOldFS("#carSlider", sliderData);
			removeOldFS("#carThumb", thumbData);
		}, false);
	}

	// remove OLD flexslider, if resize
	function removeOldFS(sliderSelector, data) {
		var slider = $(sliderSelector);
		var oldViewport = $(sliderSelector + " .flex-viewport");
		var oldNav = $(sliderSelector + " .flex-direction-nav");

		oldNav.remove();
		oldViewport.detach(":empty");
		oldViewport.css("height", "");

		setTimeout(() => {
			slider.removeData("flexslider");
			slider.flexslider(data);

			oldViewport.detach(":empty");
			notifyGalleryInit();
		}, 0);
	}
});